import React from "react";
import closeIcon from "../img/close_icon.svg";
export default function FilterButton({ title, id, removeItemFromFilter }) {
  function handleClick(e) {
    removeItemFromFilter(parseInt(e.currentTarget.id));
  }
  return (
    <div className="filter_btn mouse" onClick={handleClick} id={id}>
      {title}
      <img src={closeIcon} className="close_icon" alt="Lukk" />
    </div>
  );
}
